/* tslint:disable */
/* eslint-disable */
/**
 * Roman Swagger
 * Roman - Wire Bots Proxy
 *
 * The version of the OpenAPI document: 1.15.0
 * Contact: dejan@wire.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface NewUser
 */
export interface NewUser {
  /**
   *
   * @type {string}
   * @memberof NewUser
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof NewUser
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof NewUser
   */
  password: string;
}

export function NewUserFromJSON(json: any): NewUser {
  return NewUserFromJSONTyped(json, false);
}

export function NewUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewUser {
  if ((json === undefined) || (json === null)) {
    return json;
  }
  return {

    'name': json['name'],
    'email': json['email'],
    'password': json['password'],
  };
}

export function NewUserToJSON(value?: NewUser | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {

    'name': value.name,
    'email': value.email,
    'password': value.password,
  };
}


